import { render, staticRenderFns } from "./DropdownServiceArea.vue?vue&type=template&id=b42bb27e&"
import script from "./DropdownServiceArea.vue?vue&type=script&lang=js&"
export * from "./DropdownServiceArea.vue?vue&type=script&lang=js&"
import style0 from "./DropdownServiceArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports